import { useCallback } from "react";
import { logClickedProductAPI } from "../Services/giftService.js";
import Cookies from "js-cookie";
/**
 * Custom hook for product analytics tracking
 * @param {string} productId - Product ID
 * @param {string} opId - Optional product ID
 * @returns {Object} Analytics functions
 */
export const useProductAnalytics = (productId, opId) => {
    /**
     * Log product click for analytics
     */
    const logProductClick = useCallback(async () => {
        try {
            const params = {
                giftId: productId,
                searchSentence: localStorage.getItem("prompt"),
                giftIdMD: productId,
                giftIdOP: opId,
                userCookie: Cookies

            };

            await logClickedProductAPI(params);
        } catch (error) {
            console.error("Error logging clicked product:", error);
        }
    }, [productId, opId]);

    return {
        logProductClick,
    };
};
